import axios from 'axios'
import { detectEnvironment } from '@/core/helper-functions'

class InvestorService {
  getWhiteLabel () {
    return axios.get(`/api/white-labels/${this.getDomain()}`, {
      baseURL: process.env.VUE_APP_API,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
  }

  getDomain () {
    let host = window.location.host

    if (detectEnvironment() !== 'production') {
      const urlSearchParams = new URLSearchParams(window.location.search)
      const params = Object.fromEntries(urlSearchParams.entries())

      if (Object.hasOwn(params, 'whitelabel')) host = params.whitelabel
    }

    return host
  }
}

export default new InvestorService()
